import { render, staticRenderFns } from "./FeaturedCollection.vue?vue&type=template&id=126d7114&scoped=true&lang=pug&"
import script from "./FeaturedCollection.vue?vue&type=script&lang=js&"
export * from "./FeaturedCollection.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCollection.vue?vue&type=style&index=0&id=126d7114&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d7114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126d7114')) {
      api.createRecord('126d7114', component.options)
    } else {
      api.reload('126d7114', component.options)
    }
    module.hot.accept("./FeaturedCollection.vue?vue&type=template&id=126d7114&scoped=true&lang=pug&", function () {
      api.rerender('126d7114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/FeaturedCollection.vue"
export default component.exports